import React, {Component} from 'react';


export default class Arrcodion extends Component {

	render() {

		var id = "#"+this.props.id;
		var contentsList = this.props.contentsList;
		return (

			<div className="accrodion-regular">
                <div id={id}>
                      	{
                    		contentsList.map((content, index) => {
                    			return (

	                    			<div className="card" >
				                        <div className="card-header" id={"heading_" + content.id}>
				                            <h5 className="mb-0">
				                               <button className="btn btn-link" data-toggle="collapse" data-target={"#" + content.id} aria-expanded="true" aria-controls={content.id}>
				                                 <span className="fas fa-angle-down mr-3"></span>{content.title}
				                               </button>
				                            </h5>
				                        </div>
				                        <div id={content.id} className={content.isShow ? "collapse show" : "collapse"} aria-labelledby={"#" + content.id} data-parent={id}>
				                            <div className="card-body">
				                            	{content.component}
				                            </div>
				                        </div>
				                    </div>
			                    )

                    		})
                    	}


                   

                   
                </div>
            </div>

		)
	}
}